query AdminUnpaidInvoices {
  adminUnpaidInvoices {
    id
    organizationId
    organizationTitle
    invoiceNumber
    amountValue
    amountCurrency
    amountUSD
    invoiceDate
    expiredAt
    overdueDays
    status
  }
}
